import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';
import Index from './pages/Index'
import Reservations from './pages/Reservations'
import ReservationsCalendar from './pages/ReservationsCalendar'
import PWAInstallPrompt from './components/PWAInstallPrompt'

function App() {
  const router = createBrowserRouter([
    {
        path: '/',
        element: <Index />,
    },
    {
        path: '/reservations',
        element: <Reservations />,
    },
    {
        path: '/reservations/calendar',
        element: <ReservationsCalendar />,
    },
    ]);

    return (
      <>
        <RouterProvider router={router} />
        {/* <PWAInstallPrompt /> */}
      </>
    )
}

export default App
